"use client";
import { PageType, POIType } from "@/types";
import styles from "@/adminArea/admin.module.scss";
import AdminContent from "./AdminContent";
import { AuthProvider } from "./AuthProvider";
import { MutableRefObject } from "react";
import { TransformControls } from "three/examples/jsm/Addons.js";

export default function AdminPanel({
	page,
	animatedCameraRef,
	selected_admin_POI,
	modelRef,
	selectPOI,
	adminTransformRef,
}: {
	page: PageType;
	animatedCameraRef: MutableRefObject<any>;
	modelRef: MutableRefObject<any>;
	selected_admin_POI: POIType | null;
	selectPOI: (poi: POIType | null) => void;
	adminTransformRef: MutableRefObject<TransformControls>;
}) {
	// const { initializedMaterials } = useMaterials();

	// console.log(" => initializedMaterials", initializedMaterials);

	return (
		<AuthProvider>
			<div className={styles.adminSidebar}>
				<AdminContent modelRef={modelRef} page={page} animatedCameraRef={animatedCameraRef} selected_admin_POI={selected_admin_POI} selectPOI={selectPOI} adminTransformRef={adminTransformRef} />
			</div>
		</AuthProvider>
	);
}
